<template>
   <div class="container-fluid cntnr-table p-0" :style="{'background-color': board_bg_color}">
      <div v-if="tableLists">
         <hr class="m-0 hr-sty"/>
         <nav class="navbar navbar-dark bg-dark p-0">
         <!-- <nav class="navbar navbar-light" style="background-color: transparent;"> -->
            <div class="container-fluid">
               <span v-if="tableLists" 
                  class="navbar-brand mb-0 h1"
                  :title="appNameInModule + ` (` + boardId + `)`"
                  >
                  <b>{{appNameInModule}}</b>
               </span>
               <!--
               <div class="row justify-content-center">
                  <userCircle v-if="filterUserId > 0" :circleUser="circleUserFilter" class="col " />
                  <labelRectangle v-if="filterLabelId > 0" :label="rectangleLabelFilter" :format="hotdog" class="col pt-2 ms-1" />
                  <card-rectangle v-if="filterCardTypeId > 0" :rectangleCard="rectangleCardTypeFilter" class="col ms-1" />
               </div>
               -->
               <userCircle v-if="filterUserId > 0" :circleUser="circleUserFilter"/>
               <labelRectangle v-if="filterLabelId > 0" :label="rectangleLabelFilter" :format="hotdog"/>
               <card-rectangle v-if="filterCardTypeId > 0" :rectangleCard="rectangleCardTypeFilter"/>
               <div v-show="false" class="bg-light">
               {{filterUserId}} - 
               {{filterLabelId}} -
               {{filterCardTypeId}} -
               {{uAppIndex}}
               </div>
               <ul class="d-flex mb-0">
                  <li class="nav-item">
                     <button v-if="tableLists.columns > 0"
                        type="button" 
                        class="btn btn-dark" 
                        data-bs-toggle="modal" 
                        data-bs-target="#boardFilter"
                        :data-user-app-module-id="userAppModuleId"
                        >
                        <!--
                        -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill" viewBox="0 0 16 16">
                           <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                        </svg>
                        Filtrar&nbsp;
                     </button>
                  </li>
                  <li class="nav-item">
                     <button 
                        type="button" 
                        class="btn btn-dark" 
                        data-bs-toggle="modal" 
                        data-bs-target="#searchModal"
                        >
                        <font-awesome-icon icon="search" /> 
                        Buscar
                     </button>
                  </li>
                  <!--
                  -->
               </ul>
            </div>
         </nav>
           <!-- {{tableLists}} -->
         <div class=" table-responsive tb-cnt mt-1">
            <table class="table table-borderless"> <!-- table-border(ed/less) -->
               
               <tbody v-if="tableLists.multiRows">
                  <tr v-for="row in tableLists.rows" :key="row">
                     <td v-for="column in tableLists.columns" :key="column" class="p-0">
                        <Cell 
                           :board="tableLists" 
                           :row="row" 
                           :column="column" 
                           :cellsInBox="1"
                           class="removeCell p-1" 
                           />
                     </td>
                  </tr>
                  <tr v-if="netError">
                     <td class="i-clr">
                        <b>Error de Red</b>
                     </td>
                  </tr>
               </tbody>
               
               <tbody v-else>
                  <tr>
                     <td v-for="column in tableLists.columns" :key="column" class="p-0">
                        <Cell v-for="row in tableLists.rows" :key="row"
                           :board="tableLists" 
                           :row="row" 
                           :column="column" 
                           :cellsInBox="tableLists.cellsInBox[column - 1]"
                           class="removeCell p-1" 
                           />
                     </td>
                  </tr>
                  <tr v-if="netError">
                     <td class="i-clr">
                        <b>Error de Red</b>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
         <!--  -->
      </div>
   </div>
   <!-- llamada al modal del contenido -->
   <button v-show="false" 
      type="button" class="btn btn-sm btn-card"  
      data-bs-toggle="modal" data-bs-target="#mdContent" 
      :data-cntt-id="content.resumeContentResponse.id" 
      :data-cell-id="cell_id"
      :data-cellContent-id="content.cellContentId"
      :data-show-move-to="showMoveTo"
      id="showCntt"
   >
   </button>
   <!--  -->
   <!-- Modal -->
   <mdContent @moveTo="(val) => moveTo(val)"/>
   <mdSearchCntt @carousel="(val) => showCarousel(val)"/>
   <mdCellActions/>
   <mdNewContent/>
   <mdBoardFilter/>
   <mdBoardFilterUser/>
</template>

<script>
import { ref, onMounted, watch, computed, nextTick } from 'vue';
import { useStore } from 'vuex'

import WspService from "../workSpace.service";
import Cell from './CellTableTypeList.vue';
import mdContent from '../components/MdContentTableTypeList.vue';
import mdSearchCntt from '../components/MdSearchContent.vue';
import mdCellActions from '../components/MdCellActions.vue';
import mdNewContent from '../components/MdContentTableAdd.vue';
import mdBoardFilter from '../components/MdBoardFilter.vue';
import userCircle from '/src/components/UserCircle.vue';
import labelRectangle from '../components/LabelRectangle.vue';
import cardRectangle from "./CardRectangle.vue";

import mdBoardFilterUser from '../components/MdBoardFilterUser.vue';

export default {
   name: 'BoardTableList',
   components: {
      Cell,
      mdContent,
      mdSearchCntt,
      mdCellActions,
      mdNewContent,
      mdBoardFilter, mdBoardFilterUser,
      userCircle, labelRectangle, cardRectangle
   },
   setup() {
      const store = useStore()

      const tableLists = ref(null)
      const netError = ref(false)
      const board_bg_color = ref("#6E2C00")
      const boardId = ref(0)
      //const uAppIndex = ref(store.state.auth.userAppIndex)
      const uAppIndex = ref(0)
      const appNameInModule = ref('')

      //const doFilter = ref(false)
      const sFilterCardTypeId = ref(0)
      const sFilterUserId = ref(0)
      const sFilterLabelId = ref(0)
      const filterCardTypeId = computed(() => {
         return store.state.wspace.filterCardTypeId
      } )
      const filterUserId = computed(() => {
         return store.state.wspace.filterUserId
      } )
      const filterLabelId = computed(() => {
         return store.state.wspace.filterLabelId
      } )
      const userAppModuleId = ref(0)
      const circleUserFilter = ref({})
      const rectangleLabelFilter = ref({})
      const rectangleCardTypeFilter = ref({})
      const hotdog = "resume"
      
      const cnttToShow = ref({})
      const content = ref({
         resumeContentResponse: {
            id: 0
         },
         cellContentId: 0
      })
      const cell_id = ref(0)
      let currentIndex = 0
      const showMoveTo = ref('N')

      watch(() => store.state.auth.userAppIndex, () => {
         console.log("watch uAppIndex: "+store.state.auth.userAppIndex)
         //
         startBoard(store.state.auth.userAppIndex)
         //
      })
      /*
      */
      watch([
            () => store.state.wspace.filterLabelId, 
            () => store.state.wspace.filterUserId,
            () => store.state.wspace.filterCardTypeId, 
            ], () => {
         console.log("watch filterParameters labelId: "+store.state.wspace.filterLabelId)
         console.log("watch filterParameters userId: "+store.state.wspace.filterUserId)
         console.log("watch filterParameters cardTypeId: "+store.state.wspace.filterCardTypeId)
         nextTick(() => {
            getBoard(boardId.value)
            if (store.state.wspace.filterUserId > 0) {
               getCircleUserFilter(store.state.wspace.filterUserId)
            }
            if (store.state.wspace.filterLabelId > 0) {
               getRectangleLabelFilter(store.state.wspace.filterLabelId)
            }
            if (store.state.wspace.filterCardTypeId > 0) {
               getRectangleCardTypeFilter(store.state.wspace.filterCardTypeId)
            }
          })
      })

      onMounted(() => {
         console.log("onMounted in uAppIndex: "+uAppIndex.value)
         uAppIndex.value = store.state.auth.userAppIndex
         console.log("onMounted out uAppIndex: "+uAppIndex.value)
         //
         startBoard(store.state.auth.userAppIndex)
         //
      })
      //

      function startBoard(uaIndex) {
         uAppIndex.value = uaIndex
         if (uAppIndex.value !=  null && uAppIndex.value >= 0) {
            let uAppModule = store.state.auth.userAppModule
            if (uAppModule.appModuleComponent[uAppIndex.value].parameters) {
               //store.dispatch("wspace/updateFilterParam", 0, 0)
               store.dispatch("wspace/updateFilterCardTypeId", 0)
               store.dispatch("wspace/updateFilterUserId", 0)
               store.dispatch("wspace/updateFilterLabelId", 0)
               appNameInModule.value =  uAppModule.appModuleComponent[uAppIndex.value].nameInModule
               document.title = appNameInModule.value
               userAppModuleId.value = uAppModule.appModuleComponent[uAppIndex.value].userAppModuleId
               boardId.value = Number(uAppModule.appModuleComponent[uAppIndex.value].parameters)
               getBoard(boardId.value)
            }
         }
      }

      function getBoard(board_id) {
         console.log("this.userAppModule.parameters: "+boardId.value);
         netError.value = false;
         WspService.getBoard(board_id).then(
            (response) => {
               console.log(response.data);
               tableLists.value = response.data;
               board_bg_color.value = tableLists.value.bgColor;
               //document.title = tableLists.value.name
            },
            (error) => {
               /*
               this.content =  
                  (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
               error.message ||
               error.toString();
               console.log(error);
               netError.value = true;
               */
               console.log(error.status);
            }
         );
      }
      //

      function getCircleUserFilter(id) {
         WspService.getMyCircle(id)
         .then(response => {
            circleUserFilter.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getRectangleLabelFilter(id) {
         WspService.getMyLabel(id)
         .then(response => {
            rectangleLabelFilter.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function getRectangleCardTypeFilter(id) {
         WspService.getMyCardRectangle(id)
         .then(response => {
            rectangleCardTypeFilter.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function showCarousel( value ) {
         if ( value.length > 0 ) {
            currentIndex = 0
            cnttToShow.value = value.filter( item => item.cellContent )
            console.log(cnttToShow.value)
            moveTo( 0 )
         }
      }

      function moveTo ( value ) {
         currentIndex = currentIndex + value
         content.value = cnttToShow.value[ currentIndex ].cellContent
         cell_id.value = cnttToShow.value[ currentIndex ].cellId
         showMoveTo.value = 'B'
         if ( cnttToShow.value.length == 1 ) {
            showMoveTo.value = 'N'
         } else {
            if ( currentIndex == 0 ) {
               showMoveTo.value = 'R'
            }
            if ( currentIndex == cnttToShow.value.length - 1 ) {
               showMoveTo.value = 'L'
            }
         }
         setTimeout(() => {
            document.getElementById('showCntt').click()
         }, 350);
      }

      return {
         board_bg_color, boardId, hotdog,
         filterCardTypeId, filterUserId, filterLabelId, 
         userAppModuleId, circleUserFilter, rectangleLabelFilter, rectangleCardTypeFilter,
         sFilterCardTypeId, sFilterUserId, sFilterLabelId,
         moveTo,
         netError,
         uAppIndex, appNameInModule,
         tableLists,
         showCarousel, showMoveTo,
         content,
         cell_id
      }
   },
}
</script>

<style scoped>
.hr-sty {
   color: whitesmoke;
}
.cntnr-table {
   /*background-color: darkslategray;*/  /* orange */
   height: calc(100vh - 40px);
}
.tb-cnt {
   height: calc(100vh - 95px);
   background-color:  transparent; /*transparent  green */
}
.i-clr {
   color: white;
   text-align: center;
}
</style>